import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';

// SERVICES
import { SnackBarConfig } from '../../../shared/configs/snackbar.config';
import { SupplierContactApiService } from '../../../shared/services/api/supplier/supplier-contact-api.service';

@Component({
  selector: 'lum-supplier-contact-form',
  templateUrl: './supplier-contact-form.component.html',
  styleUrls: ['./supplier-contact-form.component.scss'],
})
export class SupplierContactFormComponent implements OnInit, OnDestroy {
  form :UntypedFormGroup;
  loading :boolean;

  private onDestroy$ = new Subject();

  constructor(
    private supplierContactApiService :SupplierContactApiService,
    @Inject(MAT_DIALOG_DATA) public data :any,
    private dialogRef :MatDialogRef<SupplierContactFormComponent>,
    private fb :UntypedFormBuilder,
    private snackbar :MatSnackBar,
  ) {}

  ngOnInit() :void {
    this.initForm();
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  onClose() :void {
    this.dialogRef.close();
  }

  onSubmit() :void {
    this.loading = true;
    this.supplierContactApiService
      .create(this.form.value)
      .pipe(
        takeUntil(this.onDestroy$),
        finalize(() => (this.loading = false)),
      )
      .subscribe({
        next: (response :any) => {
          this.dialogRef.close(response);
        },
        error: (err :any) => {
          const { error } = err;
          this.snackbar.open(
            error || 'Failed to create contact details.',
            'Close',
            {
              duration: SnackBarConfig.DEFAULT.duration,
            },
          );
        },
      });
  }

  private initForm() :void {
    this.form = this.fb.group({
      contactName: ['', [Validators.required]],
      contactEmail: ['', [Validators.required]],
      contactPhone: ['', [Validators.required]],
    });
  }

  get contactNameControl() :AbstractControl {
    return this.form.get('contactName') as UntypedFormControl;
  }

  get contactEmailControl() :AbstractControl {
    return this.form.get('contactEmail') as UntypedFormControl;
  }

  get contactPhoneControl() :AbstractControl {
    return this.form.get('contactPhone') as UntypedFormControl;
  }
}
